import {IServiceFactory} from "../../services/service-factory.interface";


export async function handleBookingFlowLogoClick(services: IServiceFactory): Promise<void> {

    await services.navigator.goHome();
    /*
    if(dontAskForConfirmation) {
        await services.navigator.goHome();
        return;
    }

    if(!services.layout.shouldUseWebappLayout || services.configuration.isAgencyPortal) {
        //if we are on mobile app or on agency portal calling goHome will trigger the confirmation from the booking step
        await services.navigator.goHome();
        return;
    }

    const result = await services.dialogFactory.showYesNoDialog({
        title: services.language.translate('Confirmation'),
        message: services.language.translate('Are you sure you want to give up?'),
        primaryButton: YesNoDialogPrimaryButton.PrimaryButtonNo
    });
    if(result === YesNoDialogResult.Yes) {
        await services.navigator.goHome();
    }

     */
}
